import { ContextItemStatus } from './interview-context-item';

/**
 * This interface defines the parent interface in order to extends every
 * answer for each type of question.
 */
export interface Answer {
    /**
     * The question identifier associated to this answer.
     */
    questionKey: string;

    /**
     * The type of the question.
     */
    questionType: QuestionType;

    /**
     * The value given from the response.
     */
    value: string | number | ResourceItemAnswer[];

    /**
     * Display text to the view
     */
    displayText?: string;

}

/**
 * Custom Interface to handle unique selection question answers.
 */
export interface ResourceItemAnswer {
    objectKey: string;
    status: ContextItemStatus;
}



/**
 * Enumeration of type of questions.
 */
export enum QuestionType {
    UNIQUE_SELECTION_QUESTION = 'UNIQUE_SELECTION_QUESTION',
    YN_QUESTION = 'YN_QUESTION',
    INTEGER_GRID_QUESTION = 'INTEGER_GRID_QUESTION',
    PLAIN_TEXT_QUESTION = 'PLAIN_TEXT_QUESTION',
    SCALED_QUESTION =  'SCALED_QUESTION',
    BOOLEAN_QUESTION = 'BOOLEAN_QUESTION',
    SELECTION_QUESTION = 'SELECTION_QUESTION',
    DATE_PICKER_QUESTION = 'DATE_PICKER_QUESTION',
    INPUT_INLINE_QUESTION = 'INPUT_INLINE_QUESTION',
    // Multi-instance questions
    HOME_LIST_MULTI_INSTANCE = 'HOME_LIST_MULTI_INSTANCE',
    PEOPLE_LIST_MULTI_INSTANCE = 'PEOPLE_LIST_MULTI_INSTANCE'
}